import { types } from "../action-types";

const initialState = {
  loading: false,
  data: {},
  error: false,
};

const getRatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_RATING_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_RATING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
      };
    case types.GET_RATING_FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: true,
      };
    default:
      return state;
  }
};

export default getRatingReducer;
